/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Session_CountInputs */

const en_field_session_count = /** @type {(inputs: Field_Session_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessions`)
};

const es_field_session_count = /** @type {(inputs: Field_Session_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesiones`)
};

const fr_field_session_count = /** @type {(inputs: Field_Session_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessions`)
};

const de_field_session_count = /** @type {(inputs: Field_Session_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitzungen`)
};

const ja_field_session_count = /** @type {(inputs: Field_Session_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セッション回数`)
};

const zh_field_session_count = /** @type {(inputs: Field_Session_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`节数`)
};

const ar_field_session_count = /** @type {(inputs: Field_Session_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الجلسات`)
};

const id_field_session_count = /** @type {(inputs: Field_Session_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesi`)
};

const it_field_session_count = /** @type {(inputs: Field_Session_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero di Sessioni`)
};

const ru_field_session_count = /** @type {(inputs: Field_Session_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Количество сеансов`)
};

const pt_field_session_count = /** @type {(inputs: Field_Session_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessões`)
};

const ko_field_session_count = /** @type {(inputs: Field_Session_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`세션 수`)
};

/**
* | output |
* | --- |
* | "Sessions" |
*
* @param {Field_Session_CountInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_session_count = /** @type {((inputs?: Field_Session_CountInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Session_CountInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_session_count(inputs)
	if (locale === "es") return es_field_session_count(inputs)
	if (locale === "fr") return fr_field_session_count(inputs)
	if (locale === "de") return de_field_session_count(inputs)
	if (locale === "ja") return ja_field_session_count(inputs)
	if (locale === "zh") return zh_field_session_count(inputs)
	if (locale === "ar") return ar_field_session_count(inputs)
	if (locale === "id") return id_field_session_count(inputs)
	if (locale === "it") return it_field_session_count(inputs)
	if (locale === "ru") return ru_field_session_count(inputs)
	if (locale === "pt") return pt_field_session_count(inputs)
	return ko_field_session_count(inputs)
});